import { CANVAS_SIZE } from '@/features/draw/constants/canvas'
import { useAvatarStore } from '@/features/draw/stores/useAvatarStore'

export function useSelectionToolsWithStore() {
    const store = useAvatarStore()

    // 从选区添加内容
    const handleAddFromSelection = (targetLayerId: number) => {
        // 确保有选区
        if (!store.selectedArea.some(isSelected => isSelected)) {
            return
        }

        const sourceLayerId = store.selectedLayerId
        const sourceLayer = store.layers.find(l => l.id === sourceLayerId)
        const targetLayer = store.layers.find(l => l.id === targetLayerId)

        if (!sourceLayer || !targetLayer) {
            return
        }

        // 创建新的像素数组
        const newTargetPixels = [...targetLayer.pixels]
        const newSourcePixels = [...sourceLayer.pixels]

        // 将选区内的像素从源图层复制到目标图层
        store.selectedArea.forEach((isSelected, index) => {
            if (isSelected && sourceLayer.pixels[index]) {
                newTargetPixels[index] = sourceLayer.pixels[index]
                // 如果目标图层不是源图层，则从源图层中清除
                if (sourceLayerId !== targetLayerId) {
                    newSourcePixels[index] = ''
                }
            }
        })

        // 更新目标图层
        store.updateLayerPixels(targetLayerId, newTargetPixels, false)

        // 如果目标图层不是源图层，则更新源图层
        if (sourceLayerId !== targetLayerId) {
            store.updateLayerPixels(sourceLayerId, newSourcePixels, false)
        }

        // 添加历史记录
        store.addHistoryEntry({
            tool: 'selection-add'
        })

        // 清除选区
        store.handleSelectionChange(Array(CANVAS_SIZE * CANVAS_SIZE).fill(false))
        store.isSelectingArea = false
    }

    return {
        handleAddFromSelection
    }
}
